import {
  Component, EventEmitter, Input, Output
} from '@angular/core';

import { Router } from '@angular/router';

export interface IDataInterface {
  type?: string,
  layout?: 'highlight' | 'image' | 'icon' | undefined
  settings?: ISettingsInterface
}

export interface ISettingsInterface {
  theme?: 'light' | 'dark' | undefined
  columns?: Number | 3
  heading?: string
  subtext?: string
  brandIcon?: string
  cards?: Array<ICardsInterface>
  buttons?: Array<IButtonsInterface>
  disclaimer?: string
}

export interface ICardsInterface {
  image?: any
  title?: string
  content?: string
  capsules?: Array<ICapsulesInterface>
  buttons?: Array<IButtonsInterface>
  links?: Array<ILinksInterface>
  category?: string
}

export interface IButtonsInterface {
  link?: string,
  label?: string | undefined
}

export interface ICapsulesInterface {
  label?: string,
  theme?: string | undefined
}

export interface ILinksInterface {
  link?: string
  label?: string
}

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent {
  @Input() data!: IDataInterface;
  @Output() startQuoteEvent = new EventEmitter<string>();

  constructor(
    private router: Router
  ) {}

  onClick(link?: any, event?: any) {
    event.preventDefault();
    this.router.navigateByUrl(`${link}`);
  }
}
